import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";
import { faqs } from "../utils";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex flex-col gap-6">
      {/* FAQ items */}
      <div className="flex flex-col gap-4">
        {Array.from({ length: faqs.length }).map((_, i) => (
          <Skeleton key={i} width="100%" height="58px" />
        ))}
      </div>

      {/* Contact section */}
      {isMobile ? (
        <div className="rounded-xl border border-[#EBEBEB] p-4 flex flex-col gap-4">
          <Skeleton width="200px" height="20px" />
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <Skeleton width="14px" height="14px" />
              <Skeleton width="140px" height="14px" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton width="14px" height="14px" />
              <Skeleton width="200px" height="14px" />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-5">
          <Skeleton width="240px" height="28px" />
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <Skeleton width="20px" height="20px" />
              <div className="flex flex-col gap-1">
                <Skeleton width="60px" height="14px" />
                <Skeleton width="160px" height="16px" />
              </div>
            </div>
            <div className="flex items-center gap-4">
              <Skeleton width="20px" height="20px" />
              <div className="flex flex-col gap-1">
                <Skeleton width="40px" height="14px" />
                <Skeleton width="240px" height="16px" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageSkeleton;
